export default (file: Blob) => {
  const size = file.size;
  return size / 1024 / 1024;
};
